import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const InfoIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                d='M9.8457 15.6504V17.0004H14.1657V15.6504H13.1217V9.8364H9.8637V11.1864H10.9437V15.6504H9.8457Z'
                fill='currentColor'
            />
            <Path
                d='M10.8717 8.0724C11.1237 8.3124 11.4477 8.4324 11.8437 8.4324C12.2397 8.4324 12.5637 8.3124 12.8157 8.0724C13.0677 7.8324 13.1877 7.5264 13.1757 7.1544C13.1757 6.7704 13.0497 6.4584 12.7977 6.2184C12.5577 5.9784 12.2397 5.8584 11.8437 5.8584C11.4477 5.8584 11.1237 5.9784 10.8717 6.2184C10.6197 6.4584 10.4937 6.7704 10.4937 7.1544C10.4937 7.5264 10.6197 7.8324 10.8717 8.0724Z'
                fill='currentColor'
            />
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z'
                fill='currentColor'
            />
        </>
    ),
})

InfoIcon.displayName = 'InfoIcon'
